import LoginEdit from './LoginEdit'

export default LoginEdit
